import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import { deserializeTimestamp, deserializeWithMappers, setFieldValues } from 'stores/Utils';
import UrlRuleStore from './UrlRuleStore';
import constants from 'Constants';
import * as utils from 'Utils';


class UrlFilterStore {

  @setter @observable urlRules;

  static create(data={}) {
    const instance = new UrlFilterStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "urlRules": [],
    };
  }

  constructor(defaults=UrlFilterStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=UrlFilterStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "urlRules", "accessor": "url_rules", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": UrlRuleStore},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  async evaluate() {
    let currentURL = utils.currentURL();

    let andResults = [];
    for (const urlRule of this.urlRules) {
      let orResults = [];

      for (const orCond of urlRule.orConditions) {
        let orResult = await utils.evaluateUrlRule(currentURL, orCond.predicate, orCond.values);
        orResults.push(orResult);
      }

      if (orResults.some((result) => result === true)) {
        andResults.push(true);
      } else {
        andResults.push(false);
      }
    }

    if (andResults.length === 0) return true;
    if (andResults.every((result) => result === true)) return true;
    return false;
  }
}

export default UrlFilterStore;



